// Mock data for Singh Logistics WA

export const COMPANY = {
  name: 'SINGH LOGISTICS WA',
  tagline: 'Refrigerated Transport Services',
  phone: '+61 423 628 121',
  phoneRaw: '+61423628121',
  address: '10 Sphinx Way, Bibra Lake WA 6163, Australia',
  email: 'karam@singhlogisticswa.com.au',
  website: 'singhlogisticswa.com.au',
  hours: 'Open 24 Hours',
};

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  {
    label: 'Services',
    href: '#services',
    children: [
      { label: 'Refrigerated Transport Perth', href: '#services' },
      { label: 'Same-Day Refrigerated Delivery', href: '#services' },
      { label: 'Emergency Refrigerated Transport', href: '#services' },
      { label: 'Scheduled Refrigerated Delivery', href: '#services' },
      { label: 'Last-Mile Cold Delivery', href: '#services' },
      { label: 'Cold Storage Solutions', href: '#about' },
    ],
  },
  { label: 'Fleet', href: '#fleet' },
  { label: 'Contact', href: '#contact' },
];

export const HERO_STATS = [
  { title: '24/7', subtitle: 'Available Round the Clock' },
  { title: 'Perth', subtitle: 'Local Service Coverage' },
  { title: 'Fast', subtitle: 'Same-Day Delivery' },
  { title: 'WAHVA', subtitle: 'Heavy Vehicle Accredited' },
];

export const SERVICES = [
  {
    title: 'Refrigerated Transport Perth',
    desc: 'Temperature-controlled transport for perishable and sensitive goods across Perth and surrounding areas.',
    image: '/images/singh-truck.jpg',
  },
  {
    title: 'Same-Day Refrigerated Delivery Perth',
    desc: 'Urgent cold-chain delivery within the same business day across Perth using our six-pallet refrigerated trucks.',
    image: '/images/truck1.jpeg',
  },
  {
    title: 'Emergency Refrigerated Transport Perth',
    desc: 'After-hours and critical cold-chain delivery when timing is everything, available 24/7.',
    image: '/images/truck2.jpeg',
  },
  {
    title: 'Scheduled Refrigerated Delivery Perth',
    desc: 'Recurring, planned cold-chain transport for businesses with regular delivery needs.',
    image: '/images/truck3.jpeg',
  },
  {
    title: 'Last-Mile Cold Delivery Perth',
    desc: 'Final-leg refrigerated delivery direct to the destination, ensuring products arrive in perfect condition.',
    image: '/images/truck44.jpg',
  },
];

export const INDUSTRIES = [
  { title: 'Restaurants & Hospitality', desc: 'Daily and on-demand cold deliveries for kitchens across Perth.', icon: 'UtensilsCrossed' },
  { title: 'Supermarkets & Retail', desc: 'Scheduled transport for perishable stock replenishment.', icon: 'ShoppingCart' },
  { title: 'Pharmaceutical & Medical', desc: 'Temperature-sensitive transport for medical supplies.', icon: 'Pill' },
  { title: 'Catering & Events', desc: 'Reliable cold delivery for events, functions, and catering.', icon: 'PartyPopper' },
  { title: 'Fresh Produce & Wholesale', desc: 'Bulk transport for wholesalers and produce distributors.', icon: 'Apple' },
  { title: 'Aged Care & Healthcare', desc: 'Dependable meal and supply delivery for care facilities.', icon: 'HeartPulse' },
];

export const FLEET = [
  {
    title: 'Small Refrigerated Trucks',
    desc: 'Versatile medium-capacity vehicles ideal for restaurant, catering, and retail deliveries.',
    image: '/images/singh-truck.jpg',
  },
  {
    title: 'Large Refrigerated Trucks',
    desc: 'High-capacity transport for wholesale, distribution, and large commercial loads.',
    image: '/images/truck1.jpeg',
  },
  {
    title: 'Refrigerated Semi-Trailers',
    desc: 'Maximum payload for large-scale distribution, regional WA, and interstate cold-chain logistics.',
    image: '/images/truck44.jpg',
  },
];

export const TESTIMONIALS = [
  {
    quote: 'Outstanding refrigerated transport service. The team at Singh Logistics WA is professional, reliable and their trucks always arrive on time. We highly recommend them to anyone looking for top-quality transport services.',
    name: 'Mimma P.',
    role: 'Google Review — 5 stars',
  },
  {
    quote: 'Great communication and fast turnaround. Our cold-chain shipments arrived in perfect condition every single time. I would highly recommend them to anyone looking for a transport service.',
    name: 'Sarah712',
    role: 'Google Review — 5 stars',
  },
  {
    quote: 'Karam and the Singh Logistics WA team have been absolutely brilliant to work with. Trustworthy operators who genuinely care about their customers and the goods they carry across Perth.',
    name: 'Perth Business Owner',
    role: 'Google Review — 5 stars',
  },
];

export const WHY_CHOOSE = [
  { title: '24/7 Availability', desc: 'We operate around the clock — nights, weekends, and public holidays. Your cold chain never sleeps, and neither do we.', icon: 'Clock' },
  { title: 'Backup Drivers on Standby', desc: 'We always have backup drivers ready to go. If plans change or emergencies arise, your delivery still happens.', icon: 'Users' },
  { title: 'Same-Day & Emergency Delivery', desc: 'Urgent needs handled fast. Same-day and emergency cold-chain transport when timing is critical.', icon: 'Zap' },
  { title: 'Flexible Fleet', desc: 'From small refrigerated trucks to semi-trailers, our diverse fleet handles any load size across Perth and WA.', icon: 'Truck' },
  { title: 'Perth Local Experts', desc: 'We know Perth inside out. Our drivers navigate the metro and surrounding areas efficiently every day.', icon: 'MapPin' },
  { title: 'Food Safety Certified', desc: 'Every delivery meets rigorous food safety standards. Your perishable goods are handled with certified care from pickup to drop-off.', icon: 'ShieldCheck' },
  { title: 'Cold Storage Solutions', desc: 'On-site refrigerated storage in Bibra Lake for short-term holding, staging, and cross-docking of your temperature-sensitive goods.', icon: 'Warehouse' },
  { title: 'WA Heavy Vehicle Accreditation (WAHVA)', desc: 'Fully accredited under the WA Heavy Vehicle Accreditation scheme — meeting the highest standards for maintenance, mass, fatigue, and safety management.', icon: 'BadgeCheck' },
];

export const FAQS = [
  {
    q: 'What areas do you service in Perth?',
    a: 'We service all Perth metropolitan suburbs and surrounding regional areas across Western Australia, including Fremantle, Joondalup, Rockingham, Mandurah, and beyond. Long-distance regional WA cold-chain delivery is also available on request.',
  },
  {
    q: 'Are you available 24/7?',
    a: 'Yes. Singh Logistics WA operates 24 hours a day, 7 days a week, including public holidays. Our team is ready to respond to urgent and emergency cold-chain deliveries around the clock.',
  },
  {
    q: 'What types of goods do you transport?',
    a: 'We transport fresh produce, dairy, seafood, meat, frozen goods, pharmaceuticals, catering food, and any temperature-sensitive product. All shipments are handled under strict food safety standards.',
  },
  {
    q: 'What size vehicles do you have?',
    a: 'Our fleet includes small and large refrigerated trucks and refrigerated semi-trailers — covering any load size from single crates to full pallet distribution.',
  },
  {
    q: 'How do I request a quote?',
    a: 'You can request a quote by calling us on +61 423 628 121, emailing karam@singhlogisticswa.com.au, or filling out the online request form. We respond within minutes during business hours.',
  },
];
